module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAvUlEQVR4AbSOuwrCQBBF9+E7WtjYBisTvyK2tpZ+o98Q/0GQWClaCDYioihkd+UGphkcQcSF4cyFe5g16of3P3nbSrJCjXrS58TLu2g8N8bkzcjOvpatV31INa+64LsRLzuljxCI2PmIsgnhhDIROx9RLuuukolcRBZlaxqVTESZjyjHl9U5vq81yCXKonzopNN9O81BKnOKcqn1IGidgVyiLMrPm1t47ycglTlFOVGb6/BRLEEuURZlKnziCwAA//9zEaqdAAAABklEQVQDALJXOR/rZlUFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warn.png
// module id = LkBP
// module chunks = 5